@if (substatuses()?.length) {
  <procure-card
    class="list"
    condensed
    [loading]="isSaving() || isLoading()"
    [loadingDiameter]="20"
  >
    @for (substatus of substatuses(); track substatus.id) {
      <div
        class="item"
        [class.clickable]="showMode() && !isSaving() && canEdit()"
        [class.active]="substatus.id === activeId()"
        (click)="update.emit(substatus)"
      >
        {{ substatus.name }}
      </div>
    }
  </procure-card>
}
